export default "__VITE_ASSET__TbeXtHY9__"